<template>
  <bizgain-component-layout :is-next-btn-enabled="true" :col-width="{ 'mx-5 px-4': !$vuetify.breakpoint.xsOnly, 'mx-2': $vuetify.breakpoint.xsOnly }" view-port-height="170px">
    <template v-slot:heading>
      {{ $t('message.bizgainOnboarding.promoteServicesHeadline') }}
    </template>
    <template v-slot:sub-heading>
      {{ $t('message.bizgainOnboarding.promoteServicesSubHeadline') }}
    </template>
    <template v-slot:content>
      <v-flex xs12 class="promote-services">
        <v-flex
          xs12
        >
          <div>
            <v-autocomplete
              class="pt-0 mt-0"
              v-model="selectedServices"
              :items="allServices"
              item-text="name"
              item-value="id"
              :placeholder="`Ex: ${allServices[0].name }`"
              name="selectedServices"
              v-validate="'required'"
              @focus="clearErrorByField($event, 'selectedServices')"
              :error="errors.has('selectedServices')"
              :error-messages="
                errors.first('selectedServices')
                  ? $t(
                    'message.bizgainOnboarding.selectedServiceWarning')
                  : null
              "
              small-chips
              multiple
              append-icon="keyboard_arrow_down"
              :return-object="true"
              :menu-props="{ maxHeight: 200 }"
            >
              <template v-slot:selection="data">
                <v-chip
                  small
                  color="primary-transperant-variant"
                  text-color="black"
                  class="selected-services"
                  :selected="data.selected"
                >
                  <span
                    class="selected-service-item"
                  >{{ data.item.name }}
                    <v-icon
                      small
                      class="
                    pr-1"
                      right
                      color="black"
                      @click="removeSelectedService(data.item)"
                    >
                      close
                    </v-icon>
                  </span>
                </v-chip>
              </template>
            </v-autocomplete>
          </div>
        </v-flex>
        <v-layout v-if="selectedServices.length > 1">
          <alert
            :icon-color="'primary'"
            :icon-width="`${ !$vuetify.breakpoint.xsOnly ? 'xs1' : 'xs2' }`"
            :outline="true"
            :outline-color="'primary'"
            :message="$t('message.bizgainOnboarding.promoteServiceAlert')"
            :col-width="'xs12 sm10'"
          />
        </v-layout>
      </v-flex>
    </template>
    <template v-slot:btn-content>
      <v-flex xs12>
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex :class="{ 'xs2': !$vuetify.breakpoint.xsOnly, 'xs12': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              class="mx-0 w-100 next-btn-color primary-btn-xs"
              :disabled="!isServiceSelected"
              @click="updateSelectedServices"
              :loading="isUpdatePromoteServices"
            >
              {{ $t('message.bizgainOnboarding.next') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
  </bizgain-component-layout>
</template>
<script>
import {
  VLayout,
  VFlex,
  VAutocomplete,
  VBtn,
  VChip,
  VIcon
} from 'vuetify/lib';
import Alert from 'Components/Alert/Alert';
import clearErrorByField from 'Mixins/clearErrorByField';
import { bizgainOnboardingRoutes, launchState, onboardingSections } from 'Features/bizgainOnboarding/constants';
import { mapActions, mapGetters } from 'vuex';
import BizgainComponentLayout from 'Components/BizgainComponentLayout/BizgainComponentLayout.vue';
import onboardingRedirect  from 'Mixins/onboardingRedirect';
export default {
  mixins: [clearErrorByField, onboardingRedirect],
  components: {
    VLayout,
    VFlex,
    VAutocomplete,
    VBtn,
    BizgainComponentLayout,
    VChip,
    VIcon,
    Alert
  },
  data() {
    return {
      selectedServices: [],
      allServices: [],
      isUpdatePromoteServices: false,
      bizgainOnboardingRoutes
    }
  },
  created() {
    this.setCurrentSection(onboardingSections.CREATIVE);
    if(this.isInAppCampaign){
      this.setCurrentRoute(bizgainOnboardingRoutes.SubsequentPromoteServices.name);
    }
    else{
      this.setCurrentRoute(bizgainOnboardingRoutes.PromoteServices.name);
    }
    this.allServices = this.services.map(function(val, index){
      return { id: index, name: val };
    });
    if (this.promoteServices){
      this.promoteServices.forEach(promoteService => {
        let selectedService = this.allServices.find(service => service.name === promoteService);
        if (selectedService) {
          this.selectedServices.push(selectedService)
        }
      });
    }
  },
  computed: {
    ...mapGetters(['isInAppCampaign', 'businessDetails', 'services', 'promoteServices', 'isError', 'businessProfileId', 'roimaticCampaignId']),
    isServiceSelected() {
      return this.selectedServices.length > 0;
    }
  },
  methods: {
    ...mapActions(['setCurrentSection', 'setCurrentRoute', 'patchBusinessDetails']),
    async updateSelectedServices() {
      if (this.selectedServices){
        try {
          if (this.businessDetails){
            this.isUpdatePromoteServices = true;
            this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
            if (this.newBusinessDetails && this.newBusinessDetails.creativeDetail) {
              this.newBusinessDetails.creativeDetail.promoteServices = this.selectedServices.map(service=>service.name);
              this.redirect({ isAppFlow: true }, { isAppFlow: true, ...this.$route.params }, false, launchState.OFFER, this.newBusinessDetails);
              if(this.isError){
                this.isUpdatePromoteServices = false;
              }
            }
          }
        }
        catch {
          this.isUpdatePromoteServices = false;
        }
      }
    },
    removeSelectedService (service) {
      this.selectedServices.splice(this.selectedServices.indexOf(service), 1);
    },
    discardChanges(){
      this.selectedServices = [];
    }
  }
}
</script>

<style lang="scss" scoped>

.selected-services.v-chip {
    height: auto !important;
}

::v-deep .selected-services.v-chip .v-chip__content{
  height: auto !important;
}

::v-deep .selected-service-item {
  white-space: initial !important;
}

</style>